<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">

      <!-- Login v1 -->
      <b-card class="mb-0">
        <b-link class="brand-logo">
          <img :src="require('@/assets/images/banner.png')" alt="" style="width: 80%">
        </b-link>

        <!-- form -->
        <validation-observer
          ref="loginForm"
          #default="{invalid}"
        >
          <b-form v-if="login"
            class="auth-login-form mt-2"
            @submit.prevent="loginNow()"
          >
        <b-card-title class="mb-1">
          مرحباً بك 👋
        </b-card-title>
        <b-card-text class="mb-2">
          قم بتسجيل الدخول للمتابعة
        </b-card-text>

            <template>
              <!-- email -->
              <b-form-group
                label-for="email"
                label="رقم الجوال"
              >
                <validation-provider
                  #default="{ errors }"
                  name="رقم الجوال"
                  rules="required"
                >
                  <b-form-input
                    id="email" class="form-control-lg"
                    v-model="userEmail"
                    name="login-email"
                    :state="errors.length > 0 ? false:null"
                    placeholder="الجوال هنا..."
                    autofocus
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="password">كلمة المرور</label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="كلمة المرور"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="password" 
                      v-model="password"
                      :type="passwordFieldType"
                      class="form-control-merge form-control-lg"
                      :state="errors.length > 0 ? false:null"
                      name="login-password"
                      placeholder="كلمة المرور هنا..."
                    />

                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </template>

            <div class="alert alert-danger text-center g" id="error" v-if="error">
              {{ error }}
            </div>

            <!-- submit button -->
            <b-button
              variant="primary"
              type="submit"
              block
              :disabled="invalid"
            >
              تسجيل الدخول
            </b-button>
            <div class="text-center">
              <br><a href="javascript:;" @click="login=false">
                <i class="fa fa-user-plus"></i>
                إنشاء حساب جديد</a>
            </div>
          </b-form>

          <b-form v-if="!login"
            class="auth-login-form mt-2"
            @submit.prevent="register()"
          >
        <b-card-title class="mb-1">
          
          إنشاء حساب جديد
        </b-card-title>
            <template>
              <b-form-group
                label-for="name"
                label="الاسم"
              >
                <validation-provider
                  #default="{ errors }"
                  name="الاسم"
                  rules="required"
                >
                  <b-form-input
                    id="name" class="form-control-lg"
                    v-model="name"
                    name="name"
                    :state="errors.length > 0 ? false:null"
                    placeholder="الاسم هنا..."
                    autofocus
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- email -->
              <b-form-group
                label-for="email"
                label="رقم الجوال"
              >
                <validation-provider
                  #default="{ errors }"
                  name="رقم الجوال"
                  rules="required"
                >
                  <b-form-input
                    id="email" class="form-control-lg"
                    v-model="userEmail"
                    name="login-email"
                    :state="errors.length > 0 ? false:null"
                    placeholder="الجوال هنا..."
                    autofocus
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="password">كلمة المرور</label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="كلمة المرور"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="password" 
                      v-model="password"
                      :type="passwordFieldType"
                      class="form-control-merge form-control-lg"
                      :state="errors.length > 0 ? false:null"
                      name="login-password"
                      placeholder="كلمة المرور هنا..."
                    />

                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </template>

            <div class="alert alert-danger text-center g" id="error" v-if="error">
              {{ error }}
            </div>

            <!-- submit button -->
            <b-button
              variant="success"
              type="submit"
              block
              :disabled="invalid"
            >
              التسجيل الآن
            </b-button>
            <div class="text-center">
              <br><a href="javascript:;" @click="login=true">
                <i class="fa fa-sign-in"></i>
                تسجيل الدخول</a>
            </div>
          </b-form>
        </validation-observer>

      </b-card>
      <!-- /Login v1 -->
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BButton, BForm, BFormInput, BFormGroup, BCard, BLink, BCardTitle, BCardText, BInputGroup, BInputGroupAppend, BFormCheckbox,
} from 'bootstrap-vue'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'

export default {
  components: {
    // BSV
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BCard,
    BCardTitle,
    BLink,
    VuexyLogo,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  created(){
    var g = this;
  },
  methods: {
    loginNow(){
      var g = this;
      $.post(api + '/user/auth/login', {
        username: g.userEmail,
        password: g.password
      })
      .then(function(r){
        if(r.status != 100){
          g.error = r.response
        }else{
          localStorage.setItem("user", JSON.stringify(r.response))
          window.location = '/'
        }
      })
      .fail(function(){
        g.error = "حدث خطأ عند الاتصال بالخادم"
      })
    },
    register(){
      var g = this;
      $.post(api + '/user/auth/register', {
        phone: g.userEmail,
        username: g.userEmail,
        password: g.password,
        name: g.name,
      })
      .then(function(r){
        if(r.status != 100){
          g.error = r.response
        }else{
          window.location = '/activate?id=' + r.response
        }
      })
      .fail(function(){
        g.error = "حدث خطأ عند الاتصال بالخادم"
      })
    }
  },
  data() {
    return {
      userEmail: window.location.href.includes("username=") ? window.location.href.split("username=")[1].split("&")[0] : "",
      password: window.location.href.includes("password=") ? window.location.href.split("password=")[1].split("&")[0] : "",
      error: null,
      login: true,
      name: "",
      // validation rules
      required,
      email,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
